'use client';

import { Switch as SwitchPrimitive } from '@base-ui/react/switch';

import { cn } from '@playbooks/ui/lib/utils';

function Switch({
	className,
	size = 'default',
	...props
}: SwitchPrimitive.Root.Props & {
	size?: 'sm' | 'default';
}) {
	// Theme
	const rootClassName = cn(
		'peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-focus focus-visible:ring-3 focus-visible:ring-focus/50 aria-invalid:border-danger aria-invalid:ring-3 aria-invalid:ring-danger/20 data-[size=default]:h-5 data-[size=default]:w-9 data-[size=sm]:h-4 data-[size=sm]:w-7 dark:aria-invalid:border-danger/50 dark:aria-invalid:ring-danger/40 data-checked:bg-action data-unchecked:bg-border-strong data-disabled:cursor-not-allowed data-disabled:opacity-50',
		className,
	);

	// Render
	return (
		<SwitchPrimitive.Root data-slot='switch' data-size={size} className={rootClassName} {...props}>
			<SwitchPrimitive.Thumb
				data-slot='switch-thumb'
				className='pointer-events-none block rounded-full bg-canvas ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[18px] group-data-[size=sm]/switch:data-checked:translate-x-[14px] dark:data-checked:bg-action-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground'
			/>
		</SwitchPrimitive.Root>
	);
}

export { Switch };
